var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_34",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m68.317,80.637c-5.977,5.969-14.457,8.705-22.796,7.355-8.339-1.35-15.523-6.621-19.311-14.171-2.105-4.195-3.021-8.809-2.749-13.367.282-4.728,2.019-9.254,4.687-13.167l21.186-31.07c.199-.291.628-.291.826,0l21.279,31.261c2.105,3.093,3.656,6.565,4.271,10.255.455,2.73.478,5.531.05,8.301-.855,5.539-3.464,10.656-7.444,14.602h0Z",
        },
      }),
      _c("circle", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { cx: "42.781", cy: "60.813", r: "3.017" },
      }),
      _c("circle", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { cx: "56.709", cy: "74.654", r: "3.017" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "40.704", y1: "76.55", x2: "58.222", y2: "59.032" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m26.915,49.453c5.694-4.487,13.571-4.577,19.36-.221h0c6.121,4.605,14.52,4.214,20.213-.942l2.899-2.625",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }